export const enResources = {
  translation: {
    underConstruction: {
      title: "We’ll be right back",
      subtitle: "Our store is currently under construction.",
      autoreload: "We’ll auto-retry in 30 seconds…",
    },
    almostThere: "Almost there!",
    pleseVerifyIdentityToCompletePurchase: "Please verify your identity to complete the purchase.",
    
    pleaseLoginToSeeTicketHistory: "Please login to see your ticket history.",
    languageChanged: "Language Changed",
    selectedLanguage: "English is now selected",
    dark: "Dark",
    light: "Light",
    systemPreferences: "System Preferences",
    changeApplicationTheme: "Select application theme",
    applicationTheme: "Application theme",
    darkDescription: "Welcome to the dark side, we have cookies!",
    lightDescription: "Embrace the light, noble gamer!",
    autoDescription: "Let your system decide your fate!",
    welcome: "Welcome",
    welcomeToBigswiss: "Welcome to Bigswiss",
    completeProfileMessage: "Please complete your profile",
    selectLanguage: "Select Default Language",
    selectLanguageLabel: "Select Language",
    gdprFadpDescription:
      "We use cookies to keep the site running and improve your experience. By selecting 'Accept Necessary,' you consent to essential cookies required for core functionality, including those from our authorised payment providers for secure transactions. By selecting 'Accept All,' you also allow optional analytics and advertising cookies so we can refine our services.",
    kycAdditionalNotice:
      "In some orders we may need to verify your identity (KYC) for fraud prevention or compliance. We will share only the data required with our vetted payments and verification partners.",
    acceptTerms: "I agree to the <0>Terms of Service</0> and <1>Privacy Policy</1>.",
    kycConsentTitle: "Verify your identity",
    kycConsentMessage:
      "For high-value or high-risk orders we may need to verify your identity. This helps us keep your account secure and comply with legal requirements before we capture the payment.",
    kycConsentLabel:
      "I consent to identity verification (including facial image processing) for fraud prevention and compliance. I have read the <0>Privacy Policy</0> and <1>Terms</1>.",
    kycConsentContinue: "I agree and continue",
    kycConsentError: "Please consent to identity verification to continue.",
    paymentRiskNotice:
      "We share limited device and order data with authorized payment and fraud-prevention providers for security. See our <0>Privacy Policy</0>.",
    acceptNecessary: "Essential Only",
    acceptAll: "Accept All",
    termsWarning: "Please agree to the terms and conditions to proceed.",
    termsPage: {
      seoTitle: "Terms & Conditions - Bigswiss GmbH",
      seoDescription:
        "Review the Bigswiss GmbH Terms and Conditions updated October 4, 2025 covering products, ordering, delivery, returns, and customer obligations.",
      heading: "Terms and Conditions",
      lastUpdated: "Last Updated: October 4, 2025",
      section1: {
        title: "1. Introduction",
        p1: "These Terms and Conditions ('Terms') govern your access to and use of the services and website of Bigswiss GmbH ('Bigswiss', 'we', 'us', or 'our'). By accessing or using our website or purchasing our products, you agree to be bound by these Terms and all policies referenced herein (including our Privacy Policy). If you do not agree with any part of these Terms, you must not use our services or website.",
        p2: "We may update these Terms from time to time. We will post any changes with a new 'Last Updated' date. Your continued use of our services after updates constitutes acceptance of the revised Terms.",
      },
      section2: {
        title: "2. Description of Products and Services",
        p1: "Bigswiss GmbH offers a wide range of video games, digital codes, gift cards, game points, and subscription cards through our online marketplace. All products sold are for personal use only and not for resale. We source these products from third-party publishers and authorized distributors. All product names, logos, and trademarks mentioned on our site are property of their respective owners, and use of those products may be subject to additional third-party terms such as end-user license agreements for game software. Bigswiss GmbH is an independent reseller and is not affiliated with the game publishers or platform providers unless explicitly stated. Purchasing a product from us grants you the right to use that product in accordance with the publisher's terms, but does not transfer any intellectual property ownership to you.",
      },
      section3: {
        title: "3. Ordering, Pricing, and Payment Terms",
        p1: "To purchase a product, you must follow the instructions on our website's checkout page. Ensure that all information you provide, such as your name, billing details, and delivery address, is accurate and complete. All prices are listed in Swiss Francs (CHF), and unless otherwise indicated, transactions will be processed in CHF. Prices include any applicable taxes, including VAT, unless stated otherwise at checkout. If you are using a payment method in a different currency, your bank or card issuer may apply currency conversion rates and fees, for which you are responsible.",
        p2: "Payment authorisation: When you confirm payment, we place an authorisation on your chosen payment method. We only capture the funds after your order passes mandatory fraud and compliance checks, which may include identity verification (KYC) before fulfilment. All payments are processed securely through vetted third-party payment service providers acting on our behalf, and Bigswiss GmbH remains the legal counterparty on your receipt or card statement.",
        p3: "Additional verification: We may ask you to submit supporting documents such as proof of address, government-issued identification, or a facial verification selfie so that our providers can authenticate the purchaser and protect against fraud. By placing an order you agree that we may share the strictly necessary data with our authorised payment and identity partners for these checks.",
        p4: "Payments are authorised at checkout and captured only after required fraud screening and, where applicable, identity verification. If verification is not completed, declined, or fails, we may cancel the order and release the authorisation without charge. We reserve the right to refuse or cancel any order we suspect of unauthorised or fraudulent activity, as further described in Section 7.",
        p5: "Third-party services: We rely on authorised third-party payment processors and fraud-prevention providers to process payments, validate transactions, and secure our platform. We only share the information necessary for them to perform these services, and every transaction is subject to their validation and authorisation checks.",
        p6: "Order acceptance: We may refuse, pause, or cancel an order if we suspect fraud, unauthorised use, or a breach of these Terms. We may also request additional information — including identity verification — before accepting or fulfilling an order.",
      },
      section4: {
        title: "4. Delivery of Digital and Physical Products",
        p1: "Digital Products: For digital goods such as game codes, gift card codes, or digital subscriptions, delivery is electronic. After your payment is confirmed, the digital product, for example a code or license key, will be delivered to you either via email or through your Bigswiss account dashboard. Delivery time: In most cases, digital deliveries are instant or completed within a few minutes of purchase. In rare cases, delivery may take up to 24 hours, for example if manual review is needed for fraud prevention. If you do not receive your digital product within the expected time frame, please check your email's spam or junk folder and then contact our support for assistance.",
        p2: "Physical Products: If we offer any physical goods, such as printed gift cards or merchandise, these will be shipped to the delivery address you provide. We currently deliver physical products to addresses within Switzerland and select international locations, as indicated on the product page or at checkout. If your order is eligible for international delivery, available destination countries will be shown at checkout. Delivery times for physical shipments vary based on destination: within Switzerland, typical shipping time is 3 to 5 business days; for international destinations, shipping may take 7 to 14 business days or longer depending on the location. Please note that these delivery times are estimates and not guaranteed, as delays can occur due to postal or customs processes.",
        p3: "For any physical shipment, you will be informed of the shipping cost, if applicable, and carrier details at checkout. Terms of delivery: We will make reasonable efforts to ship products within the advertised timeframes. However, you understand that delivery can be affected by factors beyond our control, such as courier delays or customs clearance for international shipments. Title to and risk of loss of physical goods pass to you upon delivery to the address you provided. Please ensure someone is available to receive the package. If a package is returned to us due to an incorrect address or failure to collect, we will contact you to arrange re-delivery, and additional shipping fees may apply.",
      },
      section5: {
        title: "5. Return, Refund, and Cancellation Policy",
        p1: "Returns and refunds: We want you to be satisfied with your purchase. If you are not completely happy with a product, you may request a return or refund within 7 days of purchase, referred to as the return period. We offer a hassle-free return policy: within 7 days from the date you received the product, or from the date of purchase for digital goods, you can return the product for a full refund or exchange.",
        p2: "- For digital products, such as game keys or digital codes, the code must not have been redeemed or used. We reserve the right to verify whether a digital code has been activated. If a code is verified as unused, we will deactivate it and issue you a refund or provide a replacement product per your request. If the digital product is defective, for example a code that does not work, please contact us immediately and we will either provide a working replacement code or refund your purchase.",
        p3: "- For physical products, the item must be returned in its original condition, unused and with any packaging and accessories. To initiate a return, contact our support within 7 days of delivery to obtain return instructions. You may be asked to ship the item back to us. Upon receiving the returned item in acceptable condition, we will process your refund or send a replacement according to your preference. Unless the return is due to our error or a product defect, return shipping costs may be your responsibility.",
        refundPrefix: "How to request a refund or return: To request a return or refund, please contact our customer support by email at",
        refundSuffix: "within the 7-day return period. Provide your order number, the product you wish to return, and the reason (optional). Our support team will guide you through the process. Refunds for approved returns will be issued to the original payment method you used, typically within 5 to 10 business days of approval. You will receive an email confirmation once your refund is processed. If you requested an exchange, we will ship the replacement product as soon as possible, and shipping times for exchanges may vary similarly to a new order.",
        cancellationPrefix: "Cancellation policy: If you wish to cancel an order before it has been completed or delivered, please contact us immediately at",
        cancellationSuffix: ". We can cancel your order and issue a full refund if the order is still in process and the product has not been delivered. For digital goods, this means the code has not yet been revealed or sent; for physical goods, the package has not yet been shipped. Once a digital code has been delivered to you, or a physical order has been shipped, we generally cannot cancel the order, but you may still request a return or refund as described above. In cases of pre-orders or backorders, if applicable, you may cancel for a full refund any time before the product is delivered.",
        p6: "Important: We reserve the right to refuse a return or refund, or to impose additional conditions, if we suspect abuse of our return policy. For example, excessive return requests, evidence of a used digital code being claimed as unused, or other fraudulent or dishonest behavior may result in the denial of refunds, cancellation of orders, and termination of your account as described in Section 7. Our goal is to be fair and accommodating within the policy timeline of 7 days.",
      },
      section6: {
        title: "6. Prohibition of Reselling",
        p1: "Products purchased from Bigswiss are intended for personal use only. The resale of any digital codes, gift cards, or other products obtained through Bigswiss GmbH is expressly prohibited. Any attempt to purchase products for commercial resale or to resell, redistribute, or transfer our products to a third party without our express permission is a violation of these Terms. If we determine that you are reselling products bought from us, or are purchasing on behalf of someone else for resale, we reserve the right to take action. This may include immediate termination of your account, cancellation of any outstanding orders, and refusal of future service. We also reserve the right to pursue legal action against individuals or entities engaged in unauthorized reselling of our products. By purchasing from Bigswiss, you agree not to resell or distribute the products in a commercial manner.",
      },
      section7: {
        title: "7. Fraud and Unauthorized Activities",
        p1: "We are committed to providing a safe and secure marketplace. Fraudulent or illegal activities are strictly prohibited on our site. You agree that you will not engage in any deceptive or unauthorized practices, including but not limited to using stolen or unauthorized payment methods, attempting to manipulate transactions or prices, creating multiple accounts to abuse promotions, or any form of payment fraud or identity theft. We reserve the right to cancel any order and suspend or terminate your account without notice if we suspect any fraud, unauthorized use of our services, or violation of law or these Terms.",
        p2: "If your account is terminated for fraud or misuse, you may be barred from re-registering or accessing our services in the future. We cooperate with law enforcement and payment authorities in cases of suspected fraud or illegal activity. Any fraudulent behavior may also result in legal action.",
        p3: "Additionally, you must not misuse our website by knowingly introducing viruses, attempting to gain unauthorized access to the website or any related systems, or conducting any attacks such as denial-of-service attacks. Such actions are illegal and will be reported to law enforcement, and we will take legal action as appropriate.",
      },
      section8: {
        title: "8. Intellectual Property Rights",
        p1: "All content and materials on the Bigswiss website, including text, graphics, logos, button icons, images, audio clips, and software, are the property of Bigswiss GmbH or its content suppliers and are protected by intellectual property laws. You are not permitted to copy, distribute, modify, or create derivative works from any content on our site without our prior written consent, except as allowed by law. You may electronically copy or print portions of the site for your personal use in purchasing or considering products from Bigswiss, but any other use of the site's content is prohibited.",
        p2: "As noted in Section 2, the products we sell, such as video games, digital codes, and gift cards, may include intellectual property owned by third parties. All trademarks, service marks, product names, and logos associated with the products are the property of their respective owners. Nothing in these Terms grants you any rights to use any trademarks or brand features of Bigswiss or third parties.",
        p3: "When you purchase and use third-party products, for example a game activation code or a subscription card, you agree to comply with any end-user license agreements, terms of use, or other conditions imposed by those third-party providers. Bigswiss is not responsible for the terms of service or privacy practices of third-party platforms such as Steam, Xbox, or PlayStation Network. If you have questions about the third-party terms that apply to a product, please refer to the documentation from the product's publisher or provider.",
      },
      section9: {
        title: "9. Privacy and Data Protection",
        p1: "Your privacy is important to us. Our collection and use of personal information in connection with your use of our website and services are described in our Privacy Policy, which is incorporated into these Terms by reference. You can find the full Privacy Policy on our website, and the link is available in our site footer. By using our services, you acknowledge that you have read our Privacy Policy and consent to the collection and use of your data as described.",
        p2: "In summary, when you use Bigswiss, we may collect personal data such as your name, contact details, shipping address, email, payment information, and account credentials. We keep this information secure and use it to process orders, deliver products, provide customer support, and improve our services. We share only the data necessary with trusted third parties who help us provide our services. For example, we share payment details with payment processors to charge your card and prevent fraud, your delivery address with shipping partners to deliver physical goods, and potentially your email with email service providers to send order confirmations. We do not sell your personal data to unrelated third parties. However, if required by law or to enforce our Terms, we may disclose information to authorities as outlined in our Privacy Policy.",
        p3: "Cookies: Our website uses cookies and similar technologies to enhance user experience, remember your preferences, and analyze site traffic. For details on the types of cookies we use and your choices regarding cookies, please see our Privacy Policy and Cookie Policy. By using our site, you agree to our use of cookies as described in those policies.",
        p4: "If you have any questions about how we handle your data or if you wish to exercise any data protection rights, such as accessing or deleting your data, please refer to the Privacy Policy or contact us at the email provided in the Contact Information section below.",
      },
      section10: {
        title: "10. Disclaimer of Warranties",
        p1: "Bigswiss GmbH provides the website and all products on an 'as is' and 'as available' basis. To the fullest extent permitted by law, we disclaim all warranties, express or implied, regarding our services and the products you purchase through us. This includes, but is not limited to, implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement. We do not guarantee that the website will be uninterrupted or error-free, or that any product will meet your expectations beyond the explicit descriptions on our site.",
        p2: "While we strive to ensure the accuracy of product information and that delivered digital codes or items function as intended, we make no further warranty that the products will be flawless. For example, we cannot guarantee that a digital game or service will be free of bugs or that online services run by third parties will always be available. Any warranty or support for the actual game or digital content you purchase is typically provided by the product's publisher or manufacturer, not by Bigswiss. That said, we do warrant that any digital code sold is valid and redeemable, or we will provide a working replacement or refund under our return policy. Beyond that remedy, you assume the risk of using the products.",
        p3: "Some jurisdictions do not allow the exclusion of certain warranties, so some of the above exclusions may not apply to you. In such cases, any warranties required by law are limited to the shortest period and fullest extent permitted.",
      },
      section11: {
        title: "11. Limitation of Liability",
        p1: "To the maximum extent permitted by applicable law, Bigswiss GmbH shall not be liable for any indirect, incidental, special, consequential, or punitive damages whatsoever arising out of or related to your use of our website or purchase of any products. This includes, without limitation, damages for lost profits or revenues, loss of data, loss of goodwill, or other intangible losses, even if we have been advised of the possibility of such damages.",
        p2: "Our total aggregate liability to you, for any and all claims arising out of or related to these Terms or the use of our services, is limited to the amount you paid for the product or products in question. For example, if you purchased a game code from us and have a claim related to that purchase, our liability will not exceed the price you paid for that code.",
        p3: "Bigswiss is not responsible for any delay or failure to perform that is due to causes outside our reasonable control, such as acts of God, war, terrorism, cyber-attacks, natural disasters, epidemic, governmental orders, or failures of telecommunications or internet service providers. These force majeure events excuse our performance to the extent permitted by law.",
        p4: "Nothing in these Terms shall limit or exclude our liability for gross negligence, intentional misconduct, or for any liability that cannot be excluded or limited under law, for instance certain liabilities under Swiss law or EU consumer protection law. However, in any case, we will only be liable to the extent legally obligated.",
        p5: "You agree that you use the Bigswiss services at your own risk. If you are dissatisfied with any aspect of our service or these Terms, your sole and exclusive remedy is to discontinue using the service or, where applicable, to take advantage of our return or refund policy.",
      },
      section12: {
        title: "12. Governing Law and Jurisdiction",
        p1: "These Terms and any dispute or claim arising out of or in connection with them, including non-contractual disputes, shall be governed by and construed in accordance with the laws of Switzerland, without regard to its conflict of law principles. As a consumer, you will also enjoy any mandatory protections and remedies afforded to you by the laws of your country of residence.",
        p2: "Any disputes that we cannot resolve amicably shall be subject to the exclusive jurisdiction of the courts of Switzerland. Specifically, unless otherwise required by applicable law, you agree that any legal action or proceeding arising under these Terms will be brought in the competent courts of the Canton of St. Gallen, Switzerland, which is the jurisdiction where Bigswiss GmbH is headquartered. You and Bigswiss consent to the exercise of personal jurisdiction by such courts.",
        p3: "If you are a consumer residing outside of Switzerland, you may also have the right to bring proceedings in your country of residence under certain consumer protection laws. These Terms do not limit any such right that cannot be waived by contract.",
      },
      section13: {
        title: "13. Contact Information",
        p1: "If you have any questions, concerns, or feedback about these Terms or any aspect of our services, please contact us. Our official contact details are as follows:",
        p2: "Company Name: Bigswiss GmbH (Registration No. CHE-361.327.609)",
        p3: "Registered Address: Lerchenstrasse 30, 9200 Gossau, St. Gallen, Switzerland",
        emailLabel: "Email Address:",
        emailNote: "(for customer support inquiries)",
        p4: "You can also reach us by using the contact form on our website's 'Contact Us' page. We will do our best to respond to all inquiries within 2 business days.",
        p5: "Thank you for reading our Terms and Conditions. By using Bigswiss's website and services, you signify your understanding and agreement to these Terms. We value your business and strive to provide an enjoyable, safe shopping experience for all users. If you need any further clarification about these Terms, please do not hesitate to contact us. Happy gaming!",
      },
    },
    privacyPage: {
      seoTitle: "Privacy Policy - Bigswiss GmbH",
      seoDescription:
        "Learn how Bigswiss GmbH collects, uses, and protects personal data across our digital store, wholesale tools, API integrations, and kiosk applications.",
      heading: "Privacy Policy",
      lastUpdated: "Last Updated: October 4, 2025",
      section1: {
        p1: "Bigswiss GmbH ('Bigswiss', 'we', 'us', or 'our') is committed to protecting your personal information and respecting your privacy across every channel where we operate.",
        p2: "This Privacy Policy describes the types of data we collect, how we use and share it, and the choices you have when you access our online store, wholesale portal, kiosk applications, or API services.",
      },
      section2: {
        title: "1. Data We Collect",
        p1: "We collect personal information that you provide directly to us, such as your name, contact details, delivery addresses, order history, and payment information when you create an account, place an order, or interact with support.",
        p2: "For compliance and fraud-prevention purposes we may also collect identity documentation, facial images or biometric templates generated during verification, proof-of-address materials, and records of the consent you grant for those checks.",
        p3: "We additionally receive technical and behavioural signals — for example device identifiers, browser or device fingerprints, IP addresses, authentication logs, API calls, and transaction risk scores — to help secure payments and detect abuse. Some of this data is supplied by our authorised payment and risk partners when you begin checkout.",
      },
      section3: {
        title: "2. How We Use Your Data",
        intro: "We process personal data only when we have a lawful basis and for the purposes described below:",
        items: [
          "Processing orders, delivering digital or physical products, and providing customer support.",
          "Personalising content, language, and currency preferences across our storefronts.",
          "Communicating about purchases, account updates, and optional marketing you agree to receive.",
          "Monitoring platform performance, troubleshooting issues, and improving product offerings.",
          "Verifying identity to meet anti-fraud, Know Your Customer (KYC), and anti-money-laundering obligations (based on your explicit consent and applicable legal requirements).",
          "Detecting, investigating, and preventing fraud, abuse, or security incidents in our legitimate interests and to perform our contract with you.",
          "Maintaining the records required for tax, financial, and regulatory compliance, including documenting when and how you granted or withdrew consent.",
        ],
      },
      section4: {
        title: "3. Payment Processing & Fraud Prevention",
        intro:
          "When you make a purchase, we process your payment through authorised third-party payment processors and rely on fraud-prevention providers to protect transactions. We may share:",
        items: [
          "Name, contact details, billing and delivery addresses so your order can be fulfilled.",
          "Payment account details (masked card tokens, wallet identifiers) together with the order amount, currency, and history.",
          "Device and network identifiers such as IP address, browser or device fingerprints, and session telemetry used to authenticate the transaction.",
          "Any additional information required to verify the transaction or comply with financial regulations.",
        ],
        footer:
          "Purpose & legal basis: fulfil your order (contract), prevent fraud and secure our services (legitimate interests), and comply with legal obligations where applicable. These providers are contractually bound to use your data only for these purposes and to protect it under industry-standard safeguards. We do not store full card numbers or CVV on our systems.",
      },
      section5: {
        title: "4. Identity Verification & Biometric Information",
        p1: "For certain transactions we may ask you to complete identity verification so we can satisfy compliance and anti-fraud obligations.",
        p2: "Verification can include document checks and, if you agree, biometric verification such as facial image matching. We will only collect or use biometric data with your explicit consent at the time of verification and use it solely for identity verification and fraud prevention.",
        p3: "Biometric data is encrypted and retained only as long as necessary to complete verification or as required by law, after which it is deleted or anonymised. If you do not wish to undergo biometric verification, contact support to discuss available alternatives.",
      },
      section6: {
        title: "5. When We Share Data",
        intro: "We disclose personal data only when necessary and subject to appropriate safeguards:",
        items: [
          "With trusted third-party payment processors and identity verification partners who help us authorise payments, run fraud screening, and perform KYC checks (they receive only the minimum data required).",
          "With logistics, fulfilment, and digital distribution partners so orders can be delivered and entitlements validated.",
          "With professional advisers, auditors, banks, or insurers where required for legal, compliance, or accounting purposes.",
          "With regulators, competent authorities, or law enforcement when we are legally required to do so or to protect the rights and safety of Bigswiss, our users, or others.",
          "In connection with a corporate transaction, such as a merger or acquisition, where permitted by law and subject to appropriate safeguards.",
        ],
      },
      section7: {
        title: "6. International Data Transfers",
        p1: "Your information may be stored and processed in Switzerland, the European Economic Area, the United Kingdom, or other countries where we or our vetted service providers operate. Whenever data leaves Switzerland or the EEA/UK, we rely on recognised safeguards such as Standard Contractual Clauses or the UK International Data Transfer Addendum to protect your rights.",
      },
      section8: {
        title: "7. Data Retention",
        p1: "We keep personal data only as long as necessary to fulfil the purposes described in this Policy, comply with legal obligations, resolve disputes, and enforce agreements. Payment and order records are typically retained for up to ten years under Swiss and EU accounting rules. Biometric and identity verification evidence is stored for the shorter of the applicable regulatory retention period or five years, after which it is securely deleted or irreversibly anonymised unless a longer period is mandated by law.",
      },
      section9: {
        title: "8. Cookies and Tracking Technologies",
        p1: "We use cookies, SDKs, and similar technologies to remember your preferences, keep sessions secure, analyse site usage, and support payment risk checks such as device fingerprinting. This may involve a data collection script loaded from an authorised provider during checkout. Non-essential analytics, advertising, and risk-detection cookies only run when you grant consent through the controls provided in our interfaces.",
      },
      section10: {
        title: "9. Your Rights",
        p1: "Depending on your location, you may have rights to access, correct, delete, or restrict the processing of your personal data, to receive a copy of your data in portable format, and to object to processing carried out on legitimate-interest grounds.",
        p2: "Where we rely on your consent (for example for biometric KYC checks or optional cookies) you may withdraw that consent at any time; this does not affect the lawfulness of processing before withdrawal but may prevent us from completing an order that requires verification.",
        p3: "Contact our privacy team at privacy@bigswiss.ch or at our postal address to exercise these rights or raise a concern.",
        p4: "If you are located in the EU, you can contact your local supervisory authority or the Swiss Federal Data Protection and Information Commissioner; UK residents can contact the Information Commissioner's Office. We will provide guidance on how to reach the appropriate authority upon request.",
      },
      section11: {
        title: "10. Automated Fraud Decisions",
        p1: "We use automated tools to assess transaction risk. If a transaction is declined solely due to automated processing and you are in the EU or UK, you may request human review and contest the decision.",
      },
      section12: {
        title: "11. Security Measures",
        p1: "We apply administrative, technical, and organisational safeguards to protect personal data, including encryption of credentials, secure storage of identity documents, restricted access controls, secure payment processing through trusted providers, and network protection delivered by partners such as Cloudflare. No system is entirely immune from risk, but we regularly review our defences to keep your information safe.",
      },
      section13: {
        title: "12. California Privacy Rights",
        p1: "We do not sell personal information. We use sensitive personal information (such as payment details) only to provide requested services and to prevent fraud; therefore, the California Privacy Rights Act right to limit does not apply to our current use. California residents can exercise access, deletion, correction, and other rights via the contact methods listed in this Policy.",
      },
      section14: {
        title: "13. Updates to This Policy",
        p1: "We may update this Privacy Policy to reflect operational, legal, or regulatory changes. We will post the revised version with a new 'Last Updated' date, and we encourage you to review it periodically.",
      },
      section15: {
        title: "14. Contact Us",
        p1: "If you have questions about this Privacy Policy or how Bigswiss handles your data, contact our Data Protection Officer at privacy@bigswiss.ch.",
      },
    },
    auth: {
      errors: {
        invalidCredentials: "The email or password you entered is incorrect.",
        weakPassword:
          "Choose a stronger password that meets the minimum security requirements.",
        alreadyExists:
          "An account with this email already exists. Try signing in or use a different email.",
        emailAlreadyTakenHint:
          "Email already taken. Please choose another email address or reset your password.",
        generic: "Something went wrong. Please try again.",
      },
    },
    selectCurrency: "Select Currency",
    newsletter: "Newsletter",
    subscribeMessage:
      "Subscribe to our newsletter for weekly updates and promotions.",
    subscribe: "Subscribe",
    products: "Products",
    suggestedProducts1: "Suggested",
    suggestedProducts2: "Products",
    product: "Product",
    languages: "Languages",
    language: "Language",
    menu: "Menu",
    audio: "Audio",
    subtitles: "Subtitles",
    position: "Position",
    message: "Message",
    invalidEmail: "Invalid Email",
    allFieldsRequired: "Please fill in all required fields",
    messageSent: "Message sent",
    contacted: "Request Sent",
    jobThankYou: "Thank you for your interest. We will contact you soon.",
    duplicateApplication:
      "You have already applied, please be patient until we contact you.",
    duplicateSubscription: "You are already subscribed.",
    succesSubcribed: "You have successfully subscribed.",
    company: "Company",
    getInTouch: "Get In Touch",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    pcGames: "PC Games",
    xboxGames: "XBOX Games",
    playstationGames: "PlayStation Games",
    nintendoGames: "Nintendo Games",
    giftCards: "Gift Cards",
    subscriptionCards: "Subscriptions Cards",
    aboutUs: "About us",
    testimonials: "Testimonials",
    testimonialsDescription:
      "See what our customers love about our Features. Discover how we excel in efficiency and satisfaction. Join us for low cost, retail innovation, and reliable support.",
    highlights: "Highlights",
    pricing: "Pricing",
    faqs: "FAQ",
    giftAndSubscriptionCards: "Gift & Subscription Cards",
    checkTopSellers: "Check Top Sellers",
    platforms: "Platforms",
    category: "Category",
    platform: "Platform",
    contactSupportText:
      "If you want to change your account region, please contact our support",
    region: "Region",
    productType: "Product Type",
    none: "None",
    sort: "Sort",
    priceIncreasing: "Price Increasing",
    priceDecreasing: "Price Decreasing",
    consoles: "Consoles",
    aboutUsDescription:
      "Since 2002, Bigswiss.ch has been your go-to destination for digital games and gift cards, proudly operating from the heart of Switzerland. With over two decades of experience, we are committed to bringing you the latest and greatest in the world of digital entertainment.\n\nOur extensive selection includes  wide variety of digital games across all popular platforms, as well as an array of gift cards for your favorite services. Whether you're a seasoned gamer looking for the next big release or searching for the perfect gift for a loved one, Bigswiss.ch has you covered.\n\nAt Bigswiss.ch, we pride ourselves on providing exceptional customer service and a seamless shopping experience. Our dedicated team is always here to assist you, ensuring that your journey with us is smooth and enjoyable.",
    onlineStoreTitle: "Online Store",
    onlineStoreDescription:
      "Buy over 10,000 different video games and digital products",
    posTerminalsTitle: "POS Terminals",
    posTerminalsDescription:
      "Integrate our POS Terminals in your store and get access to all our games",
    wholesaleApiTitle: "Wholesale API",
    wholesaleApiDescription: "Integrate our wholesale API to your online store",
    learnMore: "Learn More",
    goToStore: "Go to store",
    highlightsDescription:
      "Explore why our product stands out: adaptability, durability, user-friendly design, and innovation. Enjoy reliable customer support and precision in every detail.",


    FoundYour: "Found Your",
    FavoriteGenre: "Favorite Genre?",


    securePaymentsTitle: "Secure Payments",
    securePaymentsDescription: "Enjoy safe, protected transactions.",
    officialKeysTitle: "Official Keys",
    officialKeysDescription: "Keys sourced from official publishers for guaranteed authenticity.",
    instantDeliveryTitle: "Instant Delivery",
    instantDeliveryDescription:
      "Receive your digital codes instantly after purchase.",
    digitalDownloadTitle: "Digital Download",
    digitalDownloadDescription:
      "Get access to your favorite games and services with easy-to-redeem codes.",
    customerSupportTitle: "24/7 Customer Support",
    customerSupportDescription:
      "We're here for you at any time, any day, ready to resolve any issue.",
    adaptablePerformanceTitle: "Adaptable Performance",
    adaptablePerformanceDescription:
      "Our product effortlessly adjusts to your needs, boosting efficiency and simplifying your tasks.",
    innovativeFunctionalityTitle: "Innovative Functionality",
    innovativeFunctionalityDescription:
      "Stay ahead with features that set new standards, addressing your evolving needs better than the rest.",
    precisionDetailTitle: "Precision in Every Detail",
    precisionDetailDescription:
      "Enjoy a meticulously crafted product where small touches make a significant impact on your overall experience.",
    ourTopSellingProducts: "Our Top Selling Products",
    faqTitle: "Frequently asked questions",
    faq1Question:
      "How do I contact customer support if I have a question or issue?",
    faq1Answer:
      "We're here to assist you promptly. You can reach our customer support team by emailing ",
    faq2Question:
      "Can I return the product if it doesn't meet my expectations?",
    faq2Answer:
      "Absolutely! We offer a hassle-free return policy. If you're not completely satisfied, you can return the product within 7 days for a full refund or exchange.",
    faq3Question:
      "What makes your product stand out from others in the market?",
    faq3Answer:
      "Our product distinguishes itself through its adaptability, durability, and innovative features. We prioritize user satisfaction and continually strive to exceed expectations in every aspect.",
    faq4Question: "Is there a warranty on the product, and what does it cover?",
    faq4Answer:
      "Yes, our product comes with a 1 year warranty. It covers defects in materials and workmanship. If you encounter any issues covered by the warranty, please contact our customer support for assistance.",
    available: "Available",
    now: "Now",
    games: "Games",
    about: "About",
    game: "Game",
    website: "Website",
    description: "Description",
    rating: "Rating",
    developer: "Developer",
    publisher: "Publisher",
    released: "Release Date",
    genre: "Genre",
    gallery: "Gallery",
    maxPrice: "Max Price",

    availableEditions: "Available Editions",
    availablePlatforms: "Available Platforms",
    addToCart: "Add to Cart",
    outOfStock: "Out of Stock",

    emptyCartHeading: "Cart's feeling light...",
    emptyCartSubheading:
      "Your cart is longing for some company. Begin your shopping adventure now!",
    exploreCatalog: "Explore our catalog",
    yourCart: "Your Cart",
    quantity: "Quantity",
    maxProductAllowed: "Maximum of {{max}} products allowed",
    total: "Total",
    goToCart: "Go to Cart",
    payNow: "Pay Now",
    goToPayment: "Go to Payment",
    discount: "Discount",
    originalPrice: "Original Price",
    checkMoreProducts: "Check more products",
    cartSummary: "Cart Summary",
    cartItems: "Cart Items",
    payment: "Payment",
    gameActivation: "Game Activation",
    login: "Login",
    remove: "Remove",

    Notification: "Notification",
    notificationsEnabled: "Browser notifications are enabled",
    notificationsEnableFail: "Failed to enable notifications",
    notificationsDisabled: "Browser notifications are disabled",
    notificationsDisableFail: "Failed to disable notifications",
    notificationsDenied: "Notification permission was denied",
    notificationsNoPermission: "Notification permission not granted",
    notificationsPermissionFaild: "Notification permission request failed",
    notificationsNotSupported: "Push messaging is not supported",
    notificationsFailToSubscribe: "Failed to subscribe the user",
    notificationsFailToUnsubscritbe: "Failed to unsubscribe the user",
    serviceWorkerNotReady: "Please reload the page and try again",
    notificationsSubscriptionErro: "Error getting subscription",
    browserNotifications: "Browser Notifications",
    emailNotifications: "Email alerts",
    smsNotifications: "SMS alerts",
    emailNotificationsEnabled: "Email notifications enabled",
    emailNotificationsDisabled: "Email notifications disabled",
    smsNotificationsEnabled: "SMS notifications enabled",
    smsNotificationsDisabled: "SMS notifications disabled",
    retry: "Retry",
    pleaseTryAgainSoon: "Please try again in a moment.",
    pleaseTryAgain: "Please try again.",

    noProductsFound: "No products found.",
    tryDifferentQuery:
      "Please try a different search query or reset the filters.",
    resetFilters: "Reset Filters",
    achievements: "Achievements",
    achievementsPage: {
      signInTitle: "Sign in to start earning",
      signInDescription: "Log in to begin collecting achievements, leveling up, and unlocking discounts.",
      toastUnlocked: "{{title}} unlocked!",
      loadingTitle: "Loading achievements",
      loadingSubheader: "Fetching your latest progress.",
      loadingWarming: "Warming up your quest log and referral stats...",
      errorCardSubheader: "We hit a snag loading this data.",
      errorTitle: "Achievements unavailable",
      errorDetails: "{{details}} Your achievements, levels, and referral data are temporarily out of reach.",
      questErrorTitle: "Quest board offline",
      questErrorDetails: "We couldn't load your latest quests. Hit retry to fetch them again.",
      pointsAbbr: "pts",
      status: {
        locked: "Locked",
        unlocked: "Unlocked",
        completed: "Completed",
        inProgress: "In progress",
      },
      prestige: {
        activateTitle: "Activate Prestige",
        title: "Prestige",
        subheader: "Reset your level for exclusive cosmetics and bragging rights.",
        body: "Prestige levels will unlock once you reach the final loyalty tier. Each prestige resets your level while granting unique cosmetics and profile flair.",
        current: "Current Prestige: {{current}} / {{max}}",
        unavailable: "Prestige unavailable",
        activateButton: "Activate Prestige",
      },
      category: {
        purchases: "Purchase Milestones",
        spending: "Spending Mastery",
        loyalty: "Loyalty Rewards",
        community: "Community & Social",
        engagement: "Engagement Boosters",
      },
      level: {
        headerTitle: "Level {{level}} • {{name}}",
        earned: "Earned {{earned}} / {{total}} achievement points",
        progressToNext: "Earn {{points}} more achievement points to unlock {{name}}.",
        maxed: "You have reached the maximum loyalty tier. Legendary status unlocked!",
        current: "Current Level",
        next: "Next: {{name}}",
        maxedShort: "Maxed",
        legendUnlocked: "Legend unlocked",
        target: "target",
        nextLevel: "Next: Level {{level}}",
        maxLevel: "Max level",
        showMore: "Show More Stats",
        hideStats: "Hide Extra Stats",
        journeySnapshot: "Journey Snapshot",
        progressToLevel: "Earn {{points}} more achievement points to reach Level {{level}}.",
        allUnlocked: "You have unlocked every tier. Prestige rewards coming soon.",
      },
      quests: {
        title: "Quests",
        subheader: "Fresh challenges rotate daily and weekly",
        type: {
          daily: "Daily",
          weekly: "Weekly",
          seasonal: "Seasonal",
          event: "Event",
          story: "Story",
        },
        reward: "Reward:",
        expiresIn: "Expires in {{time}}",
        claim: "Claim reward",
        none: "No active quests right now. Check back soon for new challenges.",
        quest: "Quest",
        claimed: "Quest reward claimed: {{title}}",
      },
      community: {
        defaultTitle: "Community Goal • Switch Winter Drive",
        defaultDescription: "Buy any Switch title and help unlock a community-wide loot drop.",
        defaultTargetLabel: "2.5k purchases",
        contributors: "{{count}} contributors",
        complete: "{{percent}}% complete",
        target: "Target: {{target}}",
      },
      referral: {
        label: "Referral Booster",
        cardSubheader: "Track your referral progress and revenue share milestones.",
        activeProgress: "Active Progress",
        maxReferrals: "Max: {{count}} referrals",
        charged: "{{percent}}% charged",
        payout: "Payout {{percent}}%",
        currentPayoutSale: "Current payout: {{percent}}% of every sale",
        maxPayout: "Max payout {{percent}}",
        keepPowered: "Keep your Referral Booster powered by inviting players with your link.",
        verifiedPurchase: "Every verified purchase made through your link pays you {{percent}}% of the order and unlocks fresh rewards for both you and your crew.",
        purchaseGeneric: "Every purchase made through your link pays you a percentage of the sale and unlocks fresh rewards for both you and your crew.",
        shareIt: "Share it across socials, streams, or chats—each tracked order automatically charges your booster.",
        lastReferral: "Last referral: {{date}}",
        lastReferralCaptured: "Last referral captured: {{date}}",
        linkLabel: "Your referral link",
        copy: "Copy",
        copied: "Copied",
        noCodeYet: "A referral code will appear here once your booster is configured.",
        codeLabel: "Referral code: {{code}}",
        copySuccess: "Link copied to clipboard.",
        copyErrorMessage: "Unable to copy automatically. Select and copy the link manually.",
        generatingCode: "Generating referral code…",
        rewardsOverview: "Rewards overview",
        pendingBalance: "Pending balance",
        perCurrency: "Per-currency",
        unpaid: "Unpaid: {{amount}}",
        lifetime: "Lifetime: {{amount}}",
        lifetimeEarnings: "Lifetime earnings",
        trackedReferrals: "Tracked referrals",
        milestones: "Milestones",
        referralsCount: "{{count}} referrals",
        revenueSharePercent: "{{percent}}% revenue share",
        // Next reward messages
        activeMessage: "Referral Booster active.",
        maxedMessage: "You've unlocked the maximum referral share. Keep the hype going!",
        maxedSoonMessage: "Referral Booster maxed! Reward drop incoming.",
        inviteMore: "Invite {{count}} more friends to unlock {{percent}}% revenue share.",
      },
      share: {
        title: "Share your achievement",
        closeAria: "Close share dialog",
        p1: "Share your referral link across the latest product drops.",
        p2: "We auto-generate a caption for every platform, include your link, and copy it so you can publish instantly.",
        p3: "Every purchase through your link charges your booster and earns you a percentage of the sale.",
        hypeLine: "Join me on quests at the best video game shop.",
        fbBoosterLine: "Charging my Referral Booster on BigSwiss!",
        fbClaimLine: "Claim a reward drop with me!",
        igTags: "#BigSwiss #ReferralBooster #LootDrop",
        ttLine: "Game on with #BigSwiss",
        feedback: {
          sharedVia: "Shared via {{label}}.",
          copied: "{{label}} caption copied. Paste it if the share flow asks for text.",
          opened: "Opened {{label}}. If you need the caption, paste the copied text.",
        },
      },
      dashboard: {
        loadingTitle: "Loading dashboard",
        loadingSubheader: "Syncing your achievements data.",
        loadingBody: "Gathering quests and referral stats...",
        errorTitle: "Dashboard data unavailable",
        errorSubheader: "We couldn't load your latest progress.",
      },
      rewards: {
        title: "Rewards",
        subheader: "Upcoming perks based on account level",
        unlockAt: "Unlock at Level {{level}}",
        sample1: { title: "Level 2 • Weekend Drop Alert", desc: "Get early access to weekend restocks." },
        sample2: { title: "Level 3 • 5% Store Discount", desc: "Automatic discount on every purchase." },
        sample3: { title: "Level 4 • Mystery Gift", desc: "Quarterly swag shipped to your inbox." },
      },
      stats: {
        completedAchievements: "Completed Achievements",
        lifetimeSpend: "Lifetime Spend",
        averageOrder: "Average Order",
        highestOrder: "Highest Order",
        totalPurchases: "Total Purchases",
        itemsPurchased: "Items Purchased",
        purchases60Days: "Purchases (60 days)",
        storefrontsConquered: "Storefronts Conquered",
        lastPurchase: "Last Purchase",
        notYet: "Not yet",
        currentLevel: "Current Level",
      },
    },
    achievementsData: {
      categories: {
        purchases: "Purchase Milestones",
        spending: "Spending Mastery",
        loyalty: "Loyalty Rewards",
        community: "Community & Social",
        engagement: "Engagement Boosters",
      },
      common: {
        dash: "—",
        expired: "Expired",
        and: "and",
      },
      errors: {
        unable: "Unable to load achievements.",
      },
      helper: {
        locked: "Stay tuned — this quest unlocks with upcoming community tools.",
        completed: "Achievement unlocked! Enjoy your reward.",
        moreCurrency: "{{remaining}} more to go.",
        moreCount: "{{count}} more to go.",
      },
      platforms: {
        purchasedCount_one: "You've purchased {{count}} {{name}} item.",
        purchasedCount_other: "You've purchased {{count}} {{name}} items.",
      },
      levels: {
        L1: {
          name: "New Challenger",
          benefits: {
            1: "Welcome XP boost",
            2: "Early access to weekend drops",
          },
        },
        L2: {
          name: "Loot Hunter",
          benefits: {
            1: "3% discount on full-price games",
            2: "Monthly loot-crate giveaway",
          },
        },
        L3: {
          name: "Elite Raider",
          benefits: {
            1: "5% storewide discount",
            2: "Priority access to restocks",
          },
        },
        L4: {
          name: "Mythic Champion",
          benefits: {
            1: "7% discount",
            2: "Quarterly mystery gift",
          },
        },
        L5: {
          name: "Legendary Vault Guardian",
          benefits: {
            1: "10% discount",
            2: "VIP merch drops",
            3: "Personal loot concierge",
          },
        },
      },
      defs: {
        // Core progress achievements
        "first-purchase": { title: "First Loot Acquired", desc: "Complete your very first order in the BigSwiss shop." },
        "repeat-shopper": { title: "Combo Buyer", desc: "Secure 5 successful purchases across any platform." },
        "seasoned-shopper": { title: "Seasoned Collector", desc: "Hit 10 paid orders to lock in your seasoned buyer badge." },
        "haul-master": { title: "Inventory Architect", desc: "Purchase 20 individual items in total across all orders." },
        "recent-activity": { title: "Weekend Warrior", desc: "Complete 3 purchases within the last 60 days." },
        "high-ticket": { title: "Big Ticket Hunter", desc: "Make a single purchase worth at least 100 in your currency." },
        "silver-saver": { title: "Silver Saver", desc: "Accumulate 250 in lifetime spend to unlock better discounts." },
        "gold-saver": { title: "Gold Hoarder", desc: "Reach 500 in lifetime spend to unlock a gift bundle." },
        "platinum-saver": { title: "Platinum Investor", desc: "Invest 1,000 in games and gear to unlock legendary perks." },
        "loyalty-gift": { title: "Gift Drop Insider", desc: "Complete 12 paid orders to receive seasonal gifts and surprise drops." },
        "vip-raffle": { title: "VIP Raffle Access", desc: "Unlock automatic entries into community raffles by hitting 18 purchases." },

        // Platform-single achievements (platform-* ids)
        "platform-steam": { title: "Steam Store Pioneer", desc: "Purchase any Steam-powered product from the BigSwiss vault.", cta: "Buy a Steam key to unlock this badge." },
        "platform-rockstar": { title: "Rockstar Social Club Insider", desc: "Secure a Rockstar Games product and flex your Social Club status.", cta: "Grab a Rockstar code to join the club." },
        "platform-ea": { title: "EA Play Prodigy", desc: "Add an EA Play title to your library and keep the streak alive.", cta: "Purchase an EA Play product to unlock this achievement." },
        "platform-gog": { title: "GOG Galaxy Explorer", desc: "Purchase a DRM-free classic from GOG.com through BigSwiss.", cta: "Buy a GOG.com product to explore the galaxy." },
        "platform-ubisoft": { title: "Ubisoft Agent", desc: "Pick up a Ubisoft Connect title and enter the Animus in style.", cta: "Purchase a Ubisoft product to unlock this mission." },
        "platform-microsoft": { title: "Microsoft Store Commander", desc: "Buy an Xbox Live or Microsoft Store key to boost your console arsenal.", cta: "Purchase an Xbox Live product to secure this badge." },
        "platform-xbox-series-x": { title: "Series X|S Strategist", desc: "Pick up an Xbox Series X|S title to bolster your next-gen library.", cta: "Purchase an Xbox Series X|S game to claim this achievement." },
        "platform-xbox-360": { title: "Xbox 360 Historian", desc: "Grab a classic Xbox 360 title and keep the legacy alive.", cta: "Purchase an Xbox 360 game to unlock this legacy badge." },
        "platform-xbox-gift-card": { title: "Xbox Wallet Booster", desc: "Stock up your Xbox wallet with a fresh gift card from the shop.", cta: "Purchase an Xbox gift card to activate extra wallet perks." },
        "platform-playstation-4": { title: "PS4 Icon", desc: "Secure a PlayStation 4 title and keep the DualShock legacy rolling.", cta: "Purchase a PS4 game to add this icon to your wall." },
        "platform-playstation-5": { title: "PS5 Vanguard", desc: "Add a cutting-edge PS5 release to your collection.", cta: "Purchase a PS5 game to showcase next-gen mastery." },
        "platform-psn-gift-card": { title: "PSN Wallet Reloaded", desc: "Top up your PSN wallet with a gift card straight from BigSwiss.", cta: "Purchase a PSN gift card to unlock this bonus." },
        "platform-switch-game": { title: "Switch Cart Captain", desc: "Snag a Nintendo Switch game and keep your Joy-Cons in the action.", cta: "Purchase a Switch title to helm this achievement." },
        "platform-switch-gift-card": { title: "eShop Investor", desc: "Fill your Nintendo eShop wallet with a Switch gift card.", cta: "Purchase a Switch gift card to unlock eShop bonuses." },

        // Platform collections
        "platform-jumper": { title: "Platform Jumper", desc: "Shop every major storefront to prove you're a multi-verse buyer." },
        "xbox-master": { title: "Xbox Master", desc: "Purchase Series X|S, Xbox 360, and an Xbox gift card to master the Xbox vault.", complete: "All Xbox routes unlocked. Game Pass greatness achieved!", missing: "Purchase {{list}} to finish this mastery." },
        "playstation-master": { title: "PlayStation Master", desc: "Collect PS4, PS5, and PSN wallet purchases to become a PlayStation legend.", complete: "DualSense dominance unlocked. Welcome to the elite circle!", missing: "Purchase {{list}} to finish this mastery." },
        "switch-master": { title: "Switch World Explorer", desc: "Buy a Switch game and gift card to complete the hybrid collection.", complete: "Joy-Cons charged. Switch mastery achieved!", missing: "Purchase {{list}} to finish this mastery." },

        // Bulk
        "bulk-double-down": { title: "Double Down", desc: "Checkout two items in a single order.", complete: "Bulk checkout mastered.", cta: "{{remaining}} more item(s) in one order to unlock." },
        "bulk-triple-play": { title: "Triple Play", desc: "Bundle three products together at checkout.", complete: "Bulk checkout mastered.", cta: "{{remaining}} more item(s) in one order to unlock." },
        "bulk-quad-squad": { title: "Quad Squad", desc: "Purchase four items at the same time.", complete: "Bulk checkout mastered.", cta: "{{remaining}} more item(s) in one order to unlock." },
        "bulk-five-stack": { title: "Five Stack", desc: "Lock in five products within one order.", complete: "Bulk checkout mastered.", cta: "{{remaining}} more item(s) in one order to unlock." },
        "bulk-tenfold": { title: "Tenfold Haul", desc: "Score ten items in a single mega checkout.", complete: "Bulk checkout mastered.", cta: "{{remaining}} more item(s) in one order to unlock." },

        // Future
        "gift-giver": { title: "Season of Giving", desc: "Gift a game or wallet top-up to unlock festive rewards soon.", cta: "Gifting quests launch with the next holiday update." },
        "holiday-hero": { title: "Holiday Hero", desc: "Complete a special event order during the winter festival.", cta: "Limited-time holiday achievements arrive later this season." },
        "preorder-pioneer": { title: "Preorder Pioneer", desc: "Secure an upcoming release before launch day.", cta: "Preorder tracking will unlock as soon as storefront preorders go live." },
        "day-one-champion": { title: "Day-One Champion", desc: "Buy a title within 24 hours of its launch date.", cta: "Launch-day tracking is coming with our next release cadence." },
        "wishlist-closer": { title: "Wishlist Closer", desc: "Buy something straight from your wishlist queue.", cta: "Wishlist-to-cart tracking unlocks with the upcoming wishlist refresh." },
        "wishlist-sweeper": { title: "Wishlist Sweeper", desc: "Clear every item from your wishlist during a sale.", cta: "Wishlist sweeps activate when the new wishlist system ships." },
        "payment-explorer": { title: "Payment Explorer", desc: "Try alternative payment methods to earn bonus perks.", cta: "Multi-method payment tracking lands with the checkout upgrade." },
        "high-roller-weekend": { title: "High Roller Weekend", desc: "Hit a major spend milestone during a limited promo weekend.", cta: "Stay tuned—event-based spend quests arrive with seasonal promos." },
        "subscription-keeper": { title: "Subscription Keeper", desc: "Maintain an active subscription for three consecutive months.", cta: "Subscription tracking is on the roadmap—watch this space." },

        // Social/community/engagement
        "social-twitter": { title: "X Squad Broadcaster", desc: "Link your X (Twitter) account to broadcast new drops instantly.", complete: "Your X profile is synced. Keep hyping the squad!", cta: "Link X (Twitter) from Login Settings to unlock social hype rewards." },
        "social-facebook": { title: "Meta Community Builder", desc: "Connect Facebook to join exclusive followers-only giveaways.", complete: "Facebook linked. You're ready for follower-exclusive gifts.", cta: "Link Facebook from Login Settings to unlock community raffles." },
        "social-google": { title: "Google Vault Access", desc: "Secure your Google login for frictionless checkout and rewards.", complete: "Google linked. Instant sign-ins and cloud perks enabled.", cta: "Link Google from Login Settings to earn this security badge." },
        "social-steam": { title: "Steam Party Leader", desc: "Link Steam to sync your library and unlock multiplayer bonuses.", complete: "Steam linked. Squad invites and playtime quests unlocked.", cta: "Link Steam from Login Settings to join the multiplayer questline." },
        "social-xbox": { title: "Xbox Live Vanguard", desc: "Connect Xbox Live to unlock console loyalty boosts and quests.", complete: "Xbox Live linked. Console drops and game pass perks activated.", cta: "Link Xbox Live from Login Settings to earn this console badge." },
        "social-epic": { title: "Epic Vault Explorer", desc: "Connect your Epic Games profile to access cross-store drops.", complete: "Epic linked. Expect cross-store surprises soon.", cta: "Link Epic Games from Login Settings to unlock this vault badge." },
        "social-discord": { title: "Discord Squad Leader", desc: "Link your Discord account to unlock community-only giveaways.", complete: "Discord linked. Community alerts and raids are live.", cta: "Link Discord from Login Settings to unlock community giveaways." },
        "social-rockstar": { title: "Rockstar Crew Chief", desc: "Link Rockstar Social Club to sync GTA Online and Red Dead bonuses.", complete: "Rockstar account linked. Heists and posse rewards now sync automatically.", cta: "Link Rockstar Social Club from Login Settings to unlock this crew badge." },
        "social-apple": { title: "Apple Vault Guardian", desc: "Connect Apple ID for lightning-fast checkout and bonus gifts.", complete: "Apple linked. Secure purchases and wallet bonuses enabled.", cta: "Link Apple ID from Login Settings to secure this achievement." },
        "social-twitch": { title: "Twitch Stream Squad", desc: "Connect Twitch to sync drops and streamer-exclusive rewards.", complete: "Twitch linked. Stream drops now flow straight to your vault.", cta: "Link Twitch from Login Settings to unlock streamer bonuses." },
        "social-nintendo": { title: "Switch Sync Strategist", desc: "Connect Nintendo to bring eShop purchases and gold coin perks together.", complete: "Nintendo linked. Your eShop goodies now contribute to BigSwiss quests.", cta: "Link Nintendo from Login Settings to unlock cross-platform bonuses." },
        "social-kick": { title: "Kick Club Captain", desc: "Link your Kick account to join creator-only loot pools.", complete: "Kick linked. Creator-exclusive drops now appear in your feed.", cta: "Link Kick from Login Settings to unlock community creator perks." },
        "social-x": { title: "X Hype Commander", desc: "Connect your X account to broadcast new drops to your followers.", complete: "X linked. Share drop alerts straight from your timeline.", cta: "Link X from Login Settings to unlock social hype rewards." },
        "community-review": { title: "Review Champion", desc: "Leave 3 product reviews to earn bonus gifts from the shop team.", cta: "Reviews arrive with the next release of our loyalty hub." },
        "social-share": { title: "Hype Train Conductor", desc: "Share your haul on social media to unlock influencer drops.", cta: "Keep an eye out for the share-to-win feature next season." },
        "daily-login": { title: "Daily Login Streak", desc: "Maintain a 7-day streak of daily logins once streak tracking launches.", cta: "Daily streak tracking is coming soon to the rewards hub." },
        "browser-alerts": { title: "Signal Boost", desc: "Enable browser notifications to never miss a drop.", cta: "Browser notification rewards launch with the alerts update." },
      },
      jumper: {
        complete: "Every storefront cleared. Legendary shopper status unlocked.",
        stillNeed: "Still need:",
        andMore: ", and more",
      },
    },
    // Settings page toasts
    settingsPage: {
      userSettingsUpdated: "User settings updated successfully. Please relogin.",
      failedToUpdateUserSettings: "Failed to update user settings",
    },
    // Login settings toasts
    passwordsDoNotMatch: "Passwords do not match",
    passwordUpdatedSuccessfully: "Password updated successfully",
    passwordUpdateFailed: "Failed to update password",
    // Social accounts section
    socialAccounts: "Social accounts",
    connectSocialAccounts: "Link your social logins to quickly sign in with your favourite platforms.",

    noFavorites: "Oops! No Loot Found!",
    noFavoritesText: "Time to hunt for some epic loot!",
    favorites: "Favorites",
    purchases: "Purchases",
    points: "Points",
    dashboard: "Dashboard",
    settings: "Settings",
    updateSettings: "Update Settings",
    security: "Security",
    invoiceNotFound: "Invoice Not Found",
    action: "Action",
    date: "Date",
    rowsPerPage: "Rows per page",
    aboutOurApi: "About Our API",
    aboutOurApiDescription:
      "Welcome to our API product page! Our API provides seamless access to over 10,000 products, ensuring that you can integrate and offer a wide range of items to your customers all the time. Whether you're building an e-commerce platform, a mobile app, or any other service, our API has you covered.",
    whyChooseOurApi: "Why Choose Our API?",
    whyChooseOurApiDescription:
      "Our API is designed to be robust, reliable, and easy to use. Here are some of the key features:",
    featureApi1: "Access to over 10,000 products",
    featureApi2: "Real-time product availability and pricing",
    featureApi3: "High availability with 99.9% uptime",
    featureApi4: "Comprehensive documentation and support",
    featureApi5: "Easy integration with RESTful endpoints",
    featureApi6: "Secure and scalable architecture",
    WithOurApi:
      "With our API, you can ensure your customers have access to a vast inventory of products at all times. Our high availability and real-time updates mean you'll never miss a sale.",

    aboutOurPosTerminals: "About Our POS Terminals,",
    welcomeMessage:
      "Welcome to our product page! We are proud to offer state-of-the-art POS terminals designed specifically for stores that sell games and subscription cards. Our terminals are easy to use, secure, and efficient, helping you manage your sales and inventory with ease,",
    whyChooseOurPosTerminals: "Why Choose Our POS Terminals?",
    posTerminalFeatures:
      "Our POS terminals come with a range of features to streamline your store operations:",
    feature1: "Seamless integration with your existing systems",
    feature2: "Fast and secure payment processing,",
    feature3: "Real-time inventory management,",
    feature4: "User-friendly interface for quick training,",
    feature5: "Customizable settings to fit your store's needs,",
    posTerminalDescription:
      "Whether you're selling physical games or digital subscription cards, our POS terminals are equipped to handle all your transactions efficiently. Enhance your customer experience and boost your sales with our reliable and versatile POS solutions,",
    invoiceNo: "Invoice No",

    howTo: "How to",
    activate: "Activate",
    step: "Step",
    giftToFriend: "Gift to a Friend",
    enterEmailTwice:
      "Please enter your friend's email address twice for confirmation.",
    friendEmail: "Friend's Email",
    confirmFriendsEmail: "Confirm Friend's Email",
    emailsDoNotMatch: "The email addresses do not match. Please try again.",
    sendGift: "Send Gift",
    giftSent: "Gift Sent",
    giftSentMessage:
      "We have successfully sent the key as a gift to your friend at the following email:",
    close: "Close",

    buyers: "Buyers",
    reviews: "Reviews",
    user: "User",
    comment: "Comment",

    requirements: "Requirements",
    minimumRequirements: "Minimum Requirements",
    recommendedRequirements: "Recommended Requirements",
    OS: "OS",
    Processor: "Processor",
    Memory: "Memory",
    Graphics: "Graphics",
    DirectX: "DirectX",
    Storage: "Storage",
    AdditionalNotes: "Additional Notes",

    careers: "Careers",
    contactUs: "Contact Us",
    updatePersonalData: "Update your billing data",
    updateApplicationSettings: "Update Application Settings",
    birthday: "Birthday",
    yourName: "Your Name",
    yourLastName: "Your Last Name",
    enterEmail: "Enter your email address",
    yourEmail: "Your email address",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",

    
    showLess: "Show Less",
    showMore: "Show More",


    PageNotFound: "Page not found",
    DontGiveUp:
      "Don't give up, maybe you will find here what you are looking for.",
    Jobs: "Jobs",
    ElevateYourCareer:
      "Elevate your career with Bigswiss GmbH, where innovation and passion meet. Dive into a world where your work directly shapes the future of gaming and technology.",
    exploreOpportunities:
      "Explore opportunities, embrace challenges, and be part of a dynamic team dedicated to excellence. Your journey to make an impact starts here.",
    enterYourEmailAddress: "Enter your email address",
    yourEmailAddress: "Your email address",
    contactUsAgree: 'By clicking "Contact us" you agree to our',
    termsAndConditions: "Terms & Conditions",
    bigswissSupport: "Contact Bigswiss ",
    support: "Support",
    contactDescription:
      "From inquiries about our innovative online shop and wholesale store to assistance with our kiosk applications for video game purchases and the wholesale API store, we're here to elevate your experience.",
    connectTeam:
      "Connect with our dedicated team for top-tier features and services designed just for you.",

    pricingDescription: "Choose the plan that suits your needs",
    basic: "Basic",
    pro: "Pro",
    enterprise: "enterprise",
    getStarted: "Get Started",
    startNow: "Start Now",
    mostPopular: "Most Popular",
    perMonth: "per month",
    basicDesc1: "API access for up to 100 requests per month",
    basicDesc2: "Basic analytics and reporting",
    basicDesc3: "Standard support",
    proDesc1: "API access for up to 10,000 requests per month",
    proDesc2: "Advanced analytics and reporting",
    proDesc3: "Priority support",
    proDesc4: "Access to exclusive game and subscription card deals",
    enterpriseDesc1: "Unlimited API requests",
    enterpriseDesc2: "Custom analytics and reporting",
    enterpriseDesc3: "24/7 dedicated support",
    enterpriseDesc4: "Customized POS terminal solutions",
    enterpriseDesc5: "Best pricing on bulk purchases",

    chooseActivation: "Choose where you wish to activate your product.",
    thankYouForPurchase: "Thank you for your purchase!",
    findYourKeysBellow: "You can find your keys and invoice below.",
    productKey: "Product Key",
    productKeys: "Product Keys",
    productActivation: "Product Activation",
    productActivationDescription:
      "Please follow the instructions below to activate your product.",
    sendAsGift: "Gift",
    hide: "Hide",
    viewKeys: "View Keys",
    purchase_review_pending:
      "Your purchase is under review. You will receive an email once it is approved.",
    getting_key_please_wait: "Getting your key. Please wait...",
    downloadInvoice: "Download Invoice",
    download: "Download",
    back: "Back",
    next: "Next",
    activationMethod: "Activation Method",
    keylessActivation: "Keyless Activation",
    activationLink: "Activation Link",
    enterTheKey: "Enter the Key",
    confirmActivation: "Confirm Activation",
    battlenetStep1:
      "Click the button below to navigate to the Battle.net key activation page.",
    goToBattlenetActivation: "Go to Battle.net Activation Page",
    battlenetStep2:
      "Log in with your Battle.net credentials. If you don’t have an account, create one for free.",
    battlenetStep3:
      "Enter the key you received in the provided field, then click 'Redeem Code'.",
    battlenetStep4:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Battle.net account.",
    goToActivation: "Go to Activation",
    battlenetStep2app:
      "Open the Blizzard Battle.net app. And log in with your Battle.net credentials. If you don’t have an account, create one for free.",
    battlenetStep3app:
      "Click on your profile to open a menu, then click on 'Redeem Code'",
    goToSteamActivation: "Go to Steam Activation Page",
    steamStep1:
      "Click the button below to navigate to the Steam key activation page.",
    steamStep2:
      "Log in with your Steam credentials. If you don’t have an account, create one for free.",
    steamStep3:
      "Read and agree to Steam Subscriber Agreement, then click 'Continue'.",
    steamStep4:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Steam account.",
    steamStep2app:
      "Open the Steam app and log in with your Steam credentials. If you don’t have an account, create one for free.",
    steamStep3app:
      "Click on 'Games' in the top menu, then click on 'Activate a Product on Steam'.",
    steamStep4app:
      "Enter the key you received in the provided field, then click 'Confirm'.",

    goToMicrosoftActivation: "Go to Microsoft Store Activation Page",
    microsoftStep1:
      "Click the button below to navigate to the Microsoft Store key activation page.",
    microsoftStep2:
      "Log in with your Microsoft credentials. If you don’t have an account, create one for free.",
    microsoftStep3:
      "Enter the key you received in the provided field, then click 'Next'.",
    microsoftStep4:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Microsoft account.",

    microsoftStep2app:
      "On your Windows system, open the Microsoft Store app and log in with your Microsoft credentials. If you don’t have an account, create one for free.",
    microsoftStep3app:
      "Click on profile logo in top right corner, then click on 'Redeem code or gift cards'.",

    goToGOGActivation: "Go to GOG Activation Page",
    activateKey: "Activate Key",
    linkToAccount: "Link to Account",
    gogStep1:
      "Click the button below to navigate to the GOG key activation page.",
    gogStep2: "Click on 'Continue' to confirm key activation.",
    gogStep3: "Clic on 'Sign In' to link the key to your GOG account.",
    gogStep4:
      "Log in with your GOG credentials. If you don’t have an account, create one for free.",
    gogStep5:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your GOG account.",

    gogStep2app:
      "Open the GOG Galaxy app and log in with your GOG credentials. If you don’t have an account, create one for free.",
    gogStep3app:
      "Click on 'Add games & friends' in the top menu, then click on 'Redeem GOG code'.",
    gogStep4app:
      "Enter the key you received in the provided field, then click 'Continue'.",

    goToEpicActivation: "Go to Epic Games Activation Page",
    epicStep1:
      "Click the button below to navigate to the Epic Games key activation page.",
    epicStep2: "Click on 'Redeem' to confirm key activation.",
    epicStep3: "Click on 'Sign In' to link the key to your Epic Games account.",
    epicStep4:
      "Log in with your Epic Games credentials. If you don’t have an account, create one for free.",
    epicStep5:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Epic Games account.",

    epicStep2app:
      "Open the Epic Games app and log in with your Epic Games credentials. If you don’t have an account, create one for free.",
    epicStep3app:
      "Click on your profile in the top right corner, then click on 'Redeem Code'.",
    epicStep4app:
      "Enter the key you received in the provided field, then click 'Redeem'.",

    goToRockstarActivation: "Go to Rockstar Activation Page",
    rockstarStep1:
      "Click the button below to navigate to the Rockstar key activation page.",
    rockstarStep2:
      "Log in with your Rockstar credentials. If you don’t have an account, create one for free.",
    rockstarStep3:
      "Please wait for page to load, and Rockstar validation to complete. It can take up for several minutes. Once the page is loaded you will see confirmation message. Click on 'Confirm' to activate the key to your Rockstar account.",
    rockstarStep4:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Rockstar account.",
    rockstarStep2app:
      "Open the Rockstar Games Launcher app and log in with your Rockstar credentials. If you don’t have an account, create one for free.",
    rockstarStep3app:
      "Click on the menu in the top righ corner, then click on 'REDEEM CODE'.",
    rockstarStep4app:
      "Enter the key you received in the provided field, then click 'CHECK'.",
    rockstarStep5app:
      "Read and agree to the terms and conditions, then click 'REDEEM'.",

    goToEAPlayActivation: "Go to EA Play Activation Page",
    eaStep1:
      "Click the button below to navigate to the EA Play key activation page.",
    eaStep2:
      "Log in with your EA Play credentials. If you don’t have an account, create one for free.",
    eaStep3:
      "Enter the key you received in the provided field, then click 'Next'.",
    eaStep4:
      "Click on the 'Next' button to link the key to your EA Play account.",
    eaStep5:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your EA Play account.",

    eaStep2app:
      "Open the EA Play app and log in with your EA Play credentials. If you don’t have an account, create one for free.",
    eaStep3app:
      "Click on the menu in the top right corner, then click on 'Redeem Code'.",
    eaStep4app:
      "Enter the key you received in the provided field, then click 'Next'.",

    ubisoftStep5:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Ubisoft account.",
    ubisoftStep2app:
      "Open the Ubisoft app and log in with your Ubisoft credentials. If you don’t have an account, create one for free.",
    ubisoftStep3app:
      "Click on the profile menu in the top left corner, then click on 'Key Activation'.",
    ubisoftStep4app:
      "Enter the key you received in the provided field, then click 'Activate'.",

    goToSwitchActivation: "Go to Nintendo Switch Activation Page",
    openeshop: "Open eShop",
    selectUser: "Select User",
    redeem: "Redeem Key",
    switchStep1:
      "Click the button below to navigate to the Nintendo Switch key activation page.",
    switchStep2:
      "Log in with your Nintendo Switch credentials. If you don’t have an account, create one for free.",
    switchStep3:
      "Enter the key you received in the provided field, then click 'Continue'.",
    switchStep4:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Nintendo Switch account.",
    switchStep1app: "Open the Nintendo eShop app.",
    switchStep2app: "Select account where you wish to activate the product.",
    switchStep3app:
      "Enter the key you received in the provided field, then click 'Confirm'.",
    switchStep4app:
      "Select 'Redeem' and click 'Confirm' to activate the product to your Nintendo Switch account.",

    goToPlayStationActivation: "Go to PlayStation Activation Page",
    openLogin: "Open Login",
    psStep1:
      "Click the button below to navigate to the PlayStation key activation page.",
    psStep2: "In top right corner click on 'Loign'",
    psStep3:
      "Log in with your PlayStation credentials. If you don’t have an account, create one for free.",
    psStep4:
      "In top right corner click on your profile, then click on 'Redeem Code'.",
    psStep5:
      "Enter the key you received in the provided field, then click 'Continue'.",
    psStep6:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your PlayStation account.",
    openStore: "Open Store",
    psStep2console: "Select the Playstation Store on the left and ress 'X'.",
    psStep3console:
      "Press '△' to acces menu on the top right corner, select '...' and select 'Redeem Code'.",
    psStep4console:
      "Enter the key you received in the provided field, then click 'Redeem'.",
    psStep2app: "Open the PlayStation app, and open the PlayStation store.",
    openMenu: "Open Menu",
    psStep3app: "Select the menu on the top right corner, to view more option",
    psStep4app: "Select 'Redeem Code'",

    goToXboxActivation: "Go to Xbox Activation Page",
    xboxStep1:
      "Click the button below to navigate to the Xbox key activation page.",
    xboxStep2:
      "Click on 'Sign in to redeem' to log in with your Xbox credentials. If you don’t have an account, create one for free.",
    xboxStep3: "Click on 'Redeem now' to to open key activation modal.",
    xboxStep4:
      "Enter the key you received in the provided field, then click 'Next'. And continue following the instructions",
    xboxStep5:
      "Congratulations! You have successfully activated your product, and it is ready to be downloaded and played on your Xbox account.",
    xboxStep2console:
      "Press the Xbox button on your controller to open the guide. While signed with your account, select 'Store'.",
    xboxStep3console:
      "Once opened, press the view button on your controller to open the menu, then select 'Redeem'.",
    xboxStep4console:
      "Enter the key you received in the provided field, then click 'Check code'.",

    warningModalTitle: "Important Notice",
    warningModalMessage1:
      "Once you reveal the key, you lose the right for an instant refund.",
    warningModalMessage2:
      "You will only be eligible for a refund if the key is invalid.",
    doYouWantToProceed: "Do you wish to proceed?",
    revealKey: "Reveal Key",

    // chat
    helpCenter: "Help Center",
    talkWithourSupport: "Talk with support",
    haveAquestion: "Have a question?",
    typeAmessage: "Type a message...",
    hello: "Hello",
    howCanIHelpYou: "How can I help you?",
    home: "Home",
    history: "History",
    help: "Help",
    noChatMessages: "You dont have any chat history yet.",
    allHelpTopics: "All Help Topics",
    searchTopics: "Search topics...",
    noTopicsFound: "No topics found.",

    redeemingCodesCategory: "Redeeming Codes",
    findingCodesCategory: "Finding Codes",
    invoicesCategory: "Invoices",
    codeActivationIssueCategory: "Code Activation Issues",
    identityVerificationCategory: "Identity Verification",

    howToRedeem: "How to redeem the code?",
    whereToFindCodes: "Where can I find my codes?",
    whereToGetInvoice: "Where can I get an invoice for my purchase?",
    issuesActivatingCode: "I have issues activating my code",
    issuesIdentityVerification: "I have issues with my identity verification",

    howToRedeemDesc: "Follow the steps below to successfully redeem your code:",
    findingCodesDesc: "Follow the steps below to find your code:",
    invoicesDesc:
      "To access an invoice for your purchase, follow the steps below:",
    activationIssueDesc:
      "If you're experiencing problems activating your code, please check the following:",
    identityVerificationDesc:
      "If you're facing challenges with identity verification, please ensure that:",

    accessAccountTitle: "Access Your Account",
    accessAccountDesc:
      "Click on the user icon located at the top right corner of the page.",

    navigatePurchasesTitle: "Navigate to Purchases",
    navigatePurchasesDesc:
      "In the dropdown menu, select the 'Purchases' option to view your recent transactions.",

    selectRelevantPurchaseTitle: "Select the Relevant Purchase",
    selectRelevantPurchaseDesc:
      "From the purchases table, select the transaction associated with the key you wish to activate.",

    viewKeysTitle: "View Available Keys",
    viewKeysDesc:
      "Click on the 'View Keys' button to display a list of available product keys for activation.",

    revealKeyTitle: "Reveal the Key",
    revealKeyDesc: "Click the eye icon to reveal the key you wish to activate.",

    activateKeyTitle: "Activate the Key",
    activateKeyDesc:
      "Click on the 'Activate' button and follow the on-screen instructions.",

    downloadInvoiceTitle: "Download Invoice",
    downloadInvoiceDesc:
      "Click on the 'Download Invoice' button to access a PDF copy of your invoice.",

    checkTyposTitle: "Check for Typos",
    checkTyposDesc: "Ensure the code is entered correctly without typos.",

    verifyUsageTitle: "Verify Code Usage",
    verifyUsageDesc: "Verify that the code hasn't been used previously.",

    correctPlatformTitle: "Correct Platform",
    correctPlatformDesc:
      "Confirm that you're using the code in the correct platform or application.",

    clearDocumentsTitle: "Clear Documents",
    clearDocumentsDesc: "Your identification documents are clear and legible.",

    matchPersonalInfoTitle: "Match Personal Info",
    matchPersonalInfoDesc: "Your personal information matches the records.",

    supportedVerificationMethodTitle: "Supported Method",
    supportedVerificationMethodDesc:
      "You are using a supported verification method.",

    notesContactSupport:
      "If the issue persists, please contact our support team for further assistance.",
    stillHavingIssue: "Still having issues with"
  }
};
